import React from 'react';

import type {ButtonPrefixSuffix} from '../Button';
import type {RowItemProps} from './_types';

interface RowItemContextType {
  checkmarkStyle: RowItemProps['checkmarkStyle'];
  density: 'comfortable' | 'compact';
  isActive?: boolean;
  isDraggedItem?: boolean;
  isDragging?: boolean;
  isRounded?: boolean;
  isRenaming?: boolean;
  isSelected?: boolean;
  itemProps: RowItemProps & {ref: React.Ref<HTMLElement>};
  onRenameOpenChange?: RowItemProps['onRenameOpenChange'];
  prefix?: ButtonPrefixSuffix;
  rowActionsPortalRef: React.RefObject<HTMLDivElement>;
  rowItemInputPortalRef: React.RefObject<HTMLDivElement>;
  rowItemLabelRef: React.RefObject<HTMLDivElement>;
  shouldAllowRenaming?: boolean;
}

export const RowItemContext = React.createContext<RowItemContextType | null>(
  null
);

export const useRowItemContext = () => {
  const context = React.useContext(RowItemContext);
  if (!context) {
    throw new Error('useRowItemContext must be used within a RowItemProvider');
  }

  return context;
};
